import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { DevicesNomenclatureListInterface } from "../../../../redux/interfaces/admin.interface";
import { dateToString } from "../../../../utils/dateAndTime";

export const devicesNomenclatureTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Model",
    value: "model",
    minW: 24,
    withSearch: { withoutSearchIcon: true },
  },
  {
    label: "SN",
    value: "sn",
    minW: 22,
    withSearch: { withoutSearchIcon: true },
  },
  {
    label: "MAC",
    value: "mac",
    minW: 22,
    withSearch: { withoutSearchIcon: true },
  },
  {
    label: "Indicativ",
    value: "indicativ",
    minW: 18,
    withSearch: { withoutSearchIcon: true },
  },
  {
    label: "Observatii",
    value: "observatii",
    minW: 28,
  },
  {
    label: "Nume detinator",
    value: "user_username",
    minW: 14,
  },
  {
    label: "Data intrare/atribuire",
    value: "data_intrare",
    minW: 18,
  },
];

export const getDevicesNomenclatureTableData = (
  list: DevicesNomenclatureListInterface[],
): any =>
  list?.map((item) => ({
    id: item.id_echipamente,
    crudData: item,
    data: [
      { title: item.model },
      { title: item.sn },
      { title: item.mac },
      { title: item.indicativ },
      { title: item.observatii ?? "-" },
      { title: item.user_fullname ?? "-" },
      {
        badges: [
          {
            badgeText: dateToString(item.data_intrare),
            badgeColor: "light-info",
          },
          {
            badgeText: dateToString(item.data_atrib),
            badgeColor: "light-success",
          },
        ],
      },
    ],
  }));
